import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

import { QualificationPage, UnderlyingPoliciesPage, VehicleDriverHouseHoldDetailsPage, WatercraftLocationBusinessDetailsPage } from 'ml-capability-quoteandbind-common-react';
import { YourInfoPage as PUPYourInfoPage, QuotePage as PUPQuotePage } from 'gw-capability-quoteandbind-common-react';
import PUPAdditionalInformationPreBindPage from './pages/PUPAdditionalInformationPreBind/PUPAdditionalInformationPreBindPage';
import PUPDisclosuresPage from './pages/Disclosures/DisclosuresPage';

setComponentMapOverrides(
    {
        PUPYourInfoPage: { component: 'PUPYourInfoPage' },
        PUPQualificationPage: { component: 'PUPQualificationPage' },
        VehicleDriverHouseHoldDetailsPage: { component: 'VehicleDriverHouseHoldDetailsPage' },
        WatercraftLocationBusinessDetailsPage: { component: 'WatercraftLocationBusinessDetailsPage' },
        PUPUnderlyingPoliciesPage: { component: 'PUPUnderlyingPoliciesPage' },
        PUPQuotePage: { component: 'PUPQuotePage' },
        PUPAdditionalInformationPreBindPage: { component: 'PUPAdditionalInformationPreBindPage' },
        PUPDisclosuresPage: { component: 'PUPDisclosuresPage' }
    },
    {
        PUPYourInfoPage,
        PUPQualificationPage: QualificationPage,
        VehicleDriverHouseHoldDetailsPage,
        WatercraftLocationBusinessDetailsPage: WatercraftLocationBusinessDetailsPage,
        PUPUnderlyingPoliciesPage: UnderlyingPoliciesPage,
        PUPQuotePage,
        PUPAdditionalInformationPreBindPage,
        PUPDisclosuresPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PUPWizard } from './PUPWizard';
export { default as PUPPolicySummaryComponent } from './components/PUPPolicySummaryComponent/PUPPolicySummaryComponent'
